import { render, staticRenderFns } from "./MyShopTournamentsView.vue?vue&type=template&id=5f85c24b"
import script from "./MyShopTournamentsView.vue?vue&type=script&lang=js"
export * from "./MyShopTournamentsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports